var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 629.72 700.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #244858;\n      }\n      .skin-dark {\n        fill: #c69c7f;\n      }\n      .skin {\n        fill: #dcac8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.71,701H52.36C77.41,575.15,184.6,480.59,313,480.59S548.66,575.15,573.71,701Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "skin-dark",
    points: "310.94 655 260.28 565.3 209.62 475.61 311.61 477.15 413.61 478.7 362.28 566.85 310.94 655"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M545.94,275c0,119.1-143,220.52-204.69,258.75a52.81,52.81,0,0,1-55.61,0C223.93,495.52,80.94,394.1,80.94,275,80.94,123.12,185,0,313.44,0S545.94,123.12,545.94,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M111.89,283a51,51,0,0,1-68.74,21.84C18.14,291.86,0,225,0,225s65-23.75,90.05-10.8A51,51,0,0,1,111.89,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M517.83,278.28a51,51,0,0,0,68.74,21.84c25-13,43.15-79.78,43.15-79.78s-65-23.75-90.05-10.8A51,51,0,0,0,517.83,278.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset8);
export default __webpack_public_path__ + "static/media/Asset 8.d32cf2d2.svg";
export { ForwardRef as ReactComponent };